import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateExpCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateExpenseCategory = createAsyncThunk('updateExpenseCategory', async (payload) => {
  return await updateExpCategoryApi(payload);
});

const updateExpenseCategorySlice = createSlice({
  name: 'updateExpenseCategory', // Unique Name
  initialState,
  reducers: {
    updateExpenseCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateExpenseCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateExpenseCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateExpenseCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateExpenseCategoryReset } = updateExpenseCategorySlice.actions;

export default updateExpenseCategorySlice.reducer;
